import { Component, OnInit, ElementRef } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { HttpClient } from '@angular/common/http';
import { LoaderService } from 'src/modules/base/services/loader.service';

@Component({
    selector: 'app-view-prescription',
    templateUrl: './view-prescription.component.html',
    styleUrls: ['./view-prescription.component.scss'],
    standalone: false
})

export class ViewPrescriptionComponent implements OnInit {
  prescriptionsList: any = [];
  cardData: any;
  visitSummary: any;
  documentId: any;
  documentIds: any = [];
  selectedPrescription: any;
  allPresCount: any;
  formBlock:boolean=true;
  _currentPage: number = 0;
  fields: any;
  noKnownAllergy: boolean;
  configList: any = {
    "print_allowed": false,
    "viewAll": true,
    "hideSearchBox": true,
    "hideResult": true,
    "allowPagination": false,
  }
  remarks: any = '';
  configForDocument: any = {
    showTypeDropdown: false
  }
  config: any = {
    copyFields: false,
    type: 'viewAll'
  }
  copiedFields: any = {};
  remarkCopied: boolean;
  currentPrescription: string;

  constructor(private baseService: BaseService,
    private elementRef: ElementRef,
    // private modalService: SmartModalService,
    public route: ActivatedRoute,
    private storageService: StorageService,
    private appService: AppService,
    private authenticationService: AuthenticationService,
    // private alertsService: AlertsService,
    private dialogConfig: DialogConfig,
    // private dialogRef: DialogRef,
    public http: HttpClient,
    public loader: LoaderService
  ) { }

  ngOnInit() {
    this['data'] = JSON.stringify(this.dialogConfig.data) != '{}' ? this.dialogConfig.data : this.dialogConfig;
    this.baseService.getResourceDef('view_prescription', (resouceDef) => {
      console.log(resouceDef, 'resco');
      this.fields = resouceDef.list
    });
    if (this['data']) {
      this.config.copyFields = this['data'].copyFields != undefined ? this['data'].copyFields : false
      this.config.type = this['data'].type != undefined ? this['data'].type : 'viewAll';
    }
    if (this.authenticationService.getUserType() == 'patient') {
      this.getPatientData(this.authenticationService.getCurrentUser().user_id);
    } else if (this['data'] != undefined && this['data'].uhId != undefined && this.route.snapshot.queryParams.hasOwnProperty('key')) {
      this.getPatientData(this.route.snapshot.queryParams['key']);
    }
    else {
      this.storageService.getSessionStorageData("currentData", (data) => {
        if (data) {
          this.cardData = data;
          this.getAllPrescriptions();
        }
      });
    }

    // if (this.route.snapshot.queryParams.hasOwnProperty('key'))
    //   var args = "id:" + this.route.snapshot.queryParams.key;
    // this.baseService.get("get_patient_data_for_appointment", args, "appointment", "appointment").subscribe(data => {
    //   if (data.resource) {
    //     this.cardData = data.resource[0];
    //     this.getAllPrescriptions();
    //     console.log(this.cardData, 'this.cardData');
    //   }
    // })
  }
  getPatientData(id) {
    let data = {
      args: "id:" + id
    }
    this.baseService.getData(data, "", "patient", "patient-registration", "GET_BY_ID").subscribe(
      res => {
        if (res) {
          this.cardData = res.resource[0];
          this.cardData['patient_id'] = res.resource[0].id
          this.getAllPrescriptions();
        }
      }
    )
  }

  getAllPrescriptions() {
    let resourceData = {
      queryId: 'GET_EPRESCRIPTION_BY_ID',
      args: ``,
      resource: 'e_prescription',
      application: 'emr'
    }
    var data = {
      args: "uhId:" + (this.cardData['uhId'] ? this.cardData['uhId'] : this.cardData['UHID']) + ",status:final",
    };
    if (this.config.type == 'viewAll') {
      data['page_no'] = this._currentPage;
      data['page_size'] = 10;
    }
    else {
      data['args'] = data['args'] + ",encounter_id:" + this.cardData['encounter_id'];
    }
    this.baseService.getData(data, "", resourceData.resource, resourceData.application, resourceData.queryId).subscribe(res => {
      // this.baseService.get(resourceData.queryId, data.args, resourceData.resource, resourceData.application, data['filter']).subscribe(res => {
      this.prescriptionsList = res.resource;
      this.allPresCount = res.count;
      this.onClickSideList(this.prescriptionsList[0]);
    }, err => {
      console.error("Api gives Error", err);
    });
  }

  // isArray(data) {
  //   if (typeof data === 'string' || data instanceof String) {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // }

  onClickSideList(list, event?, index?) {
    this.formBlock=true;
    console.log(list, 'list');
    this.currentPrescription = undefined;
    this.documentId = undefined;
    this.remarks = undefined;
    this.selectedPrescription = list;
    let target;
    if (event && event.currentTarget) {
      target = event.currentTarget;
      let child = this.elementRef.nativeElement.getElementsByClassName('doc-view-list');
      for (let cl of child) {
        cl.classList.remove("doc-active-tab");
      }
      target.classList.add("doc-active-tab");
    }
    if (list != undefined) {
      if (list.visit_summary_detail) {
        // var app_name = this.baseService.printApplicationName("ePrescription");
        var url = location.origin + "/printengine/api/v1/e_prescription/print?args=facility_id:" + this.appService.getOrganization().org_id + ",status:" + this.selectedPrescription.status + ",primaryKeyIdentifier:" + this.selectedPrescription.encounter_id + ",encounter_id:" + this.selectedPrescription.encounter_id + ",uhId:" + this.selectedPrescription.uhId + ",patient_type:" + this.selectedPrescription.patient_type + ",reportTemplateId:ePrescription,contentType:pdf,appPrint:Y&application=emr";
        this.downloadFile(url);
        // this.noKnownAllergy = list.noKnownAllergy
        // this.documentId = "";
        // this.documentIds = [];
        // this.visitSummary = list.visit_summary_detail;
        // this.visitSummary.forEach(element => {
        //   element.type_id = element.fieldName.replace(/\s+/g, '');
        //   try {
        //     if (element.fieldName.toLowerCase() == 'observations') {
        //       element.fieldDetail = JSON.parse(element.fieldDetail);
        //       element.fieldDetail.forEach((detail, index) => {
        //         let data = {
        //           args: `uhId:${this.cardData.uhId},observationId:${detail.observationId},templateType:physical_examination`,
        //           page_size: 10,
        //           page_no: 0
        //         }
        //         this.baseService.getData(data, "", 'observation', 'diagnostic', 'GET_TEMPLATE_BY_UHID').subscribe((result: any) => {
        //           if (result.errCode == 0 && result.count > 0) {
        //             element.fieldDetail[index]['fieldDetail'] = JSON.parse(result.resource[0].template[detail.templateId]);
        //           }
        //         })
        //       });
        //     } else
        //       element.fieldDetail = JSON.parse(element.fieldDetail);
        //   } catch (e) { }
        // });
        // if (list.medicineType == 'brand') { }
        // this.fields['Medication Order'].find(element => (element.name == 'form_type')).hidden = true;
        // else { }
        // this.fields['Medication Order'].find(element => (element.name == 'form_type')).hidden = false;
      } else if (list.documentId) {
        this.noKnownAllergy = false
        this.visitSummary = [];
        this.documentId = list.documentId;
        if (typeof (this.documentId) == 'string') {
          let tempId = {
            "documentId": this.documentId
          }
          this.documentId = [];
          this.documentId.push(tempId);
        }
        this.documentIds = this.documentId;
      } else if (list.documentIds) {
        this.noKnownAllergy = false
        this.visitSummary = [];
        this.documentIds = list.documentIds;
        this.documentId = list.documentIds[0].documentId;
      } else { }
      this.remarks = (list.remarks != undefined && list.remarks != '') ? list.remarks : "";
    }
  }

  downloadFile(url: string): any {
    this.loader.showSpinner();
    return this.http.get(url, { responseType: 'blob' }).subscribe((result: any) => {
      const blobTest = new Blob([result], { type: 'application/pdf' });
      this.currentPrescription = URL.createObjectURL(blobTest);
      this.loader.hideSpinner();
    })
  }

  printPrescription() {
    // var app_name = this.baseService.printApplicationName("ePrescription");
    window.open(location.origin + "/printengine/api/v1/e_prescription/print?args=facility_id:" + this.appService.getOrganization().org_id + ",status:" + this.selectedPrescription.status + ",primaryKeyIdentifier:" + this.selectedPrescription.encounter_id + ",encounter_id:" + this.selectedPrescription.encounter_id + ",uhId:" + this.selectedPrescription.uhId + ",patient_type:" + this.selectedPrescription.patient_type + ",reportTemplateId:ePrescription,contentType:pdf,appPrint:Y&application=emr", '_blank');
  }

  goPrev() {
    if (this._currentPage && this._currentPage != 0 && this.allPresCount > this._currentPage) {
      this._currentPage = this._currentPage - 1;
      return this.getAllPrescriptions();
    }
  }

  goNext() {
    this._currentPage = this._currentPage + 1;
    return this.getAllPrescriptions();
  }

  getClassToEnableDisableIcon() { // setting goNext icon disabled if datasource reaches maximum limit
    if (this.allPresCount > 0) {
      var lastPage = this.allPresCount / 10;
      if (lastPage > this._currentPage + 1) {
        return null;
      } else {
        return true;
      }
    }
  }

  // copyFieldsInPrescription(data, entity?: any) {
  //   console.log(data, 'data');
  //   if (data.fieldName == 'remark') {
  //     this.remarkCopied = !this.remarkCopied;
  //     if (this.remarkCopied == true)
  //       this.alertsService.info("" + data.fieldName + " copied successfully..")
  //     else
  //       this.alertsService.info("Copied data removed from clipboard of " + data.fieldName + " field..")

  //     data['fieldDetail'] = this.remarks;
  //     this.copyFields(data, undefined, this.remarkCopied);
  //   }
  //   this.visitSummary.forEach((element, index) => {
  //     if (element.fieldName == data.fieldName) {
  //       if (this.visitSummary[index].copy != undefined) {
  //         this.visitSummary[index].copy = !this.visitSummary[index].copy
  //         if (this.visitSummary[index].copy == true) {
  //           this.copyFields(data, entity, this.visitSummary[index].copy);
  //           this.alertsService.info("" + data.fieldName + " copied successfully..")
  //         } else {
  //           this.copyFields(data, entity, this.visitSummary[index].copy);
  //           this.alertsService.info("Copied data removed from clipboard of " + data.fieldName + " field..")
  //         }
  //       }
  //       else {
  //         this.visitSummary[index].copy = true
  //         this.copyFields(data, entity, this.visitSummary[index].copy);
  //         this.alertsService.info("" + data.fieldName + " copied successfully..")
  //       }
  //       return;
  //     }
  //   });
  // }
  // copyFields(data, entity, copy) {
  //   if (data.fieldName == "Medication Order") {
  //     if (copy == true) {
  //       this.copiedFields['medicineType'] = this.selectedPrescription.medicineType
  //       this.copiedFields[entity.name] = data.fieldDetail;
  //     }
  //     else {
  //       delete this.copiedFields['medicineType'];
  //       delete this.copiedFields[entity.name]
  //     }
  //   }
  //   else {
  //     var name = entity != undefined ? entity.name : data.fieldName
  //     if (copy == true)
  //       this.copiedFields[name] = data.fieldDetail;
  //     else
  //       delete this.copiedFields[name]
  //   }
  // }

  // openClipboard() {
  //   this.dialogRef.close(this.copiedFields)

  //   // this.modalService.sendResult(this.copiedFields);
  // }
  closeButton() {
    this.currentPrescription = undefined;
    this.documentId = undefined;
    this.formBlock =false;
  }
}
